import { Card, Button } from 'react-bootstrap';
import './index.css';

const ProjectDetail = (props) => {
  return (
    <Card bg={'light'}>
      <Card.Img
        variant="top"
        src={`https://eclipsesp-app.herokuapp.com/resource/storage/image/logo/${props.projek.logo}`}
      />
      <Card.Body>
        <Card.Title> {props.projek.nama_aplikasi} </Card.Title>
        <Card.Text>
          {props.projek.deskripsi_aplikasi.slice(0, 50)} . . . . . .
        </Card.Text>
        <Button
          variant="outline-dark"
          onClick={() => props.detailProject(props.projek.nama_aplikasi_slug)}
        >
          see more
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ProjectDetail;
